import { useEffect, useState } from "react";

/** Patch 30: true while the element is on screen (`once`: stays true after the first time). */
export function useInView(ref, { once = false, rootMargin = "0px" } = {}) {
  const [v, setV] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setV(true);
      return undefined;
    }
    const io = new IntersectionObserver(([e]) => {
      setV(e.isIntersecting);
      if (e.isIntersecting && once) io.disconnect();
    }, { rootMargin });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, once, rootMargin]);
  return v;
}
